import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_QRCodeVue = _resolveComponent("QRCodeVue")!

  return (_openBlock(), _createBlock(_component_QRCodeVue, {
    value: _ctx.value,
    size: _ctx.size
  }, null, 8, ["value", "size"]))
}